// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"560":"d3ab1885","633":"910d1af1"}[chunkId] + ".chunk.js";
};